<template lang='pug'>
  .campaign-list(v-loading="loading")
    el-breadcrumb(
      separator="/"
      style="padding-bottom: 20px"
    )
      el-breadcrumb-item {{ $t('项目列表') }}
    .campaign-list__header
      .campaign-list__header__buttons
        el-button(
          v-if="showAddCampaign"
          @click="addNewCampaign"
          class="addNewProject__btn"
          plain
        )
          i(style="margin-right: 5px").iconfont.icon-wujiaoxing
          span {{ $t('新建媒体投放项目') }}
      .campaign-list__header__filter
        i(
          v-if="isFilterCollapse"
          @click="isFilterCollapse = false"
        ).iconfont.icon-shaixuanxian
        i(
          v-else
          @click="isFilterCollapse = true"
        ).iconfont.icon-shaixuanmian
        el-input(
          :placeholder="$t('搜索项目名称/ID')"
          style="width: 200px"
          v-model="currentKeyword"
          @keyup.enter.native="handleSearch"
        )
          i(
            v-show="currentKeyword !== ''"
            slot="suffix"
            class="el-input__icon el-icon-circle-close"
            style="cursor: pointer"
            @click="handleClearInput"
          )
          i(
            slot="suffix"
            class="el-input__icon el-icon-search"
            style="cursor: pointer"
            @click="handleSearch"
          )
        //- el-button(type="primary" style="margin-left: 20px;background-color: #4896e6" @click="showDialog = true") {{ $t('导出Brief信息') }}
    filter-panel(
      v-if="!isFilterCollapse"
      @clear="fetchCampaignList"
      @confirm="handleSearch"
    )
    select-brief-info-dialog(
      v-if="showDialog"
      @close="showDialog = false"
    )
    el-table.campaign-list__table(
      :data='campaignList'
      :row-class-name="tableRowClassName"
    )
      el-table-column(
        prop='campaign_id'
        :label='$t("项目ID")'
        align='left'
        min-width="95"
      )
      el-table-column(
        prop='campaign_name'
        :label='$t("项目名称")'
        align='left',
        min-width="130"
        show-overflow-tooltip
      )
      el-table-column(
        prop='brand_name'
        :label='$t("品牌")'
        align='left'
        show-tooltip-when-overflow
      )
      el-table-column(
        prop='budget',
        :label='$t("预算")'
        align='left'
        min-width="110"
        show-tooltip-when-overflow
        :formatter="(row) => numberWithCommas(row.budget/10000, 1) + '万元'"
      )
      el-table-column(
        :label='$t("状态")'
        align='left',
        :min-width="isEn && '165'"
      )
        template(slot-scope="scope")
            span {{ getStatus(scope.row.status) }}
      el-table-column(
        :label='$t("操作")'
        align='left'
        min-width="160"
      )
        template(slot-scope='scope')
          .campaign-list__operation
            el-button(
              type="text"
              @click='handleView(scope.row)'
            ) {{ $t('查看') }}
            el-button(
              type="text"
              :disabled="!showAddCampaign || scope.row.can_be_delete === 0"
              @click='handleDelete(scope.row.campaign_id)'
            ) {{ $t('删除') }}
    el-pagination.campaign-list__pagination(
      layout='prev, pager, next, jumper'
      :page-size='10'
      :total='total'
      :current-page.sync='currentPage'
      @current-change='fetchCampaignList'
    )
</template>

<script>
import axios from 'axios'
import { numberWithCommas, formatDate } from '@/umcc/util'
import db from '@/umcc/db'
import FilterPanel from './components/FilterPanel'
import SelectBriefInfoDialog from './components/SelectBriefInfoDialog'
// import SearchInputWithDelete from '@/components/SearchInputWithDelete'

export default {
  data () {
    return {
      campaignList: null,
      loading: false,
      currentPage: 1,
      total: null,
      currentKeyword: '',
      isFilterCollapse: true,
      showDialog: false
    }
  },
  components: {
    FilterPanel,
    SelectBriefInfoDialog
  },
  computed: {
    isView () {
      return this.$store.state.common.user.permissions.includes('Management_Campaign_C')
    },
    isEn () {
      return db.lang === 'en'
    },
    keyword () {
      return this.$store.state.campaign.campaignListKeyword
    },
    pageNumber () {
      return this.$store.state.campaign.campaignListPageNumber
    },
    showAddCampaign () {
      return this.$store.state.common.user.permissions.includes('Management_EC_Campaign_C')
    },
    brandCategoryId () {
      return this.$store.state.campaign.ecCampaignListBrandCategoryId
    },
    brandId () {
      return this.$store.state.campaign.ecCampaignListBrandId
    },
    shopId () {
      return this.$store.state.campaign.ecCampaignListShopId
    },
    status () {
      return this.$store.state.campaign.ecCampaignListStatus
    },
    channelId () {
      return this.$store.state.campaign.ecCampaignListChannel
    },
    campaignType () {
      return this.$store.state.campaign.ecCampaignListType
    }
  },
  watch: {
    $route () {
      this.$store.commit('campaign/setCampaignListPageNumber', 1)
      this.$store.commit('campaign/setECCampaignListStatus', null)
      this.$store.commit('campaign/setECCampaignListType', 1)
      this.$store.commit('campaign/setCampaignListKeyword', '')
      this.$store.commit('campaign/setECCampaignListChannel', null)
      this.$store.commit('campaign/setECCampaignListBrandCategoryId', null)
      this.$store.commit('campaign/setECCampaignListBrandId', null)
      this.$store.commit('campaign/setECCampaignListShopId', null)
      this.currentKeyword = ''
      this.currentPage = 1
      this.fetchCampaignList()
    }
  },
  mounted () {
    this.currentKeyword = this.keyword
    this.currentPage = this.pageNumber
    this.fetchCampaignList()
  },
  filters: {
    numberWithCommas,
    formatDate
  },
  methods: {
    numberWithCommas,
    tableRowClassName ({row}) {
      return row.status === 2 ? 'disabled-row' : ''
    },
    getStatus (status) {
      switch (status) {
        case 0:
          return this.$t('草稿')
        case 1:
          return this.$t('进行中')
        case 2:
          return this.$t('已失效')
        case 3:
          return this.$t('完成')
      }
    },
    fetchCampaignList () {
      this.loading = true
      this.$store.commit('campaign/setCampaignListPageNumber', this.currentPage)
      this.$store.commit('campaign/setCampaignListKeyword', this.currentKeyword)
      axios.get('/management/ec/getCampaignList', {
        params: {
          page_size: 10,
          page_number: this.pageNumber,
          keyword: this.keyword,
          brand_category_id: this.brandCategoryId,
          brand_id: this.brandId,
          shop_id: this.shopId,
          status: this.status,
          channel_id: this.channelId,
          type: this.campaignType
        }
      })
        .then(res => {
          this.loading = false
          this.campaignList = res.table_data
          this.total = res.total_row
        })
        .catch(err => {
          throw new Error(err)
        })
    },
    handleSearch () {
      this.currentPage = 1
      this.fetchCampaignList()
    },
    handleClearInput () {
      this.currentKeyword = ''
      if (this.keyword !== '') {
        this.handleSearch()
      }
    },
    addNewCampaign () {
      this.$store.commit('campaign/setId', null)
      this.$store.dispatch('campaign/updateECTab')
      this.$router.push({
        path: '/ec-campaign/new-campaign'
      })
    },
    handleView (row) {
      this.loading = true
      this.$store.commit('campaign/setId', row.campaign_id)
      this.$router.push('/ec-campaign/overview')
    },
    handleDelete (id) {
      this.$confirm(this.$t('项目将为失效状态，且不可撤销，请确认是否继续。'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      })
        .then(() => {
          this.confirmDelete(id)
        })
    },
    confirmDelete (id) {
      axios.get('/management/ec/delete', {
        params: {
          campaign_id: id
        }
      })
        .then(() => {
          this.$message.success(this.$t('删除成功'))
          this.fetchCampaignList()
        })
        .catch(err => {
          throw new Error(err)
        })
    }
  }
}
</script>

<style lang="stylus">
.campaign-list
  .campaign-list__header
    display flex
    justify-content space-between
    .el-button
      display flex
      justify-content space-around
      > span
        display flex
        align-items center
    .el-input
      width 180px
  .campaign-list__header__filter
    display flex
    align-items center
    .iconfont
      color $main
      margin-right 24px
  .campaign-list__pagination
    margin-top 20px
    float right
    .btn-next,.btn-prev
      background none !important
    .el-pager li
      background none
  .campaign-list__table
    margin-top 20px
  .addNewProject__btn
    background #4896e6
    box-shadow: 0 0 15px 0 rgba(72, 150, 230, 0.41)
    color #ffffff
    font-weight normal
    width 198px
    height 35px
    font-size 14px
    margin-bottom 24px
    &.el-button--default
      border none
    &:hover
      background #4896e6 !important
      color #ffffff !important
      border-color #4896e6 !important
  .el-table
    .disabled-row
      color $disabled
      td
        &:nth-child(2)
          text-decoration line-through
</style>
